import moment from 'moment';
import PropTypes from 'prop-types';

export function getTerminalDates({ date = new Date(), end, range, init = true }) {
	let start_date;
	let end_date;
	if (init) {
		start_date = moment(new Date(date.getFullYear(), date.getMonth(), 1));
		end_date = moment(date).endOf('day');
	} else if (end) {
		start_date = moment(date).endOf('day').subtract(range, 'days');
		end_date = moment(date);
	} else {
		start_date = moment(date);
		end_date = moment(date).endOf('day').add(range, 'days');
	}
	if (moment(end_date) > moment().endOf('day')) {
		end_date = moment().endOf('day');
	}
	return { startDate: start_date, endDate: end_date };
}

getTerminalDates.propTypes = {
	date: PropTypes.object || null,
	end: PropTypes.bool,
	range: PropTypes.number,
	init: PropTypes.bool,
};
